<div class="timer-container">
    <h4>
        <span class="time-block">{{ remainingTime.days | number:'2.0' }}</span>д 
        <span class="time-block">{{ remainingTime.hours | number:'2.0' }}</span>ч 
        <span class="time-block">{{ remainingTime.minutes | number:'2.0' }}</span>м 
        <span class="time-block">{{ remainingTime.seconds | number:'2.0' }}</span>с
    </h4>
</div>
